module.exports = __webpack_public_path__ + "static/img/press.eb0cc448.png";